import { Form, TextArea } from 'components/common'

export interface NoteFormProps {
  defaultValue?: string
}

const maxLength = 2000

export const NoteForm = ({ defaultValue }: NoteFormProps) => {
  return (
    <>
      <Form.Item
        name="note"
        label="メモ (最大2000文字)"
        labelCol={{ span: 24 }}
        initialValue={defaultValue}
        rules={[
          {
            type: 'string',
            max: maxLength,
          },
        ]}
      >
        <TextArea autoComplete="off" maxLength={maxLength} showCount />
      </Form.Item>
    </>
  )
}
